module.exports = __webpack_public_path__ + "img/first-section-2.ae09cd61.jpg";